import { RouteFactory } from "@app/routePaths";
import { sectionNavigationItems } from "@util/constant";

export const SUB_MOBILE_NAVIGATION = [
  {
    key: "home",
    link: RouteFactory.home,
    label: "Top Stories",
    trackingData: {
      ref: "home-menubar",
    },
  },
  {
    ...sectionNavigationItems["breaking-news"],
    label: "Breaking",
    trackingData: {
      ref: "home-menubar",
    },
  },
  {
    key: "pulse",
    link: RouteFactory.pulse,
    label: "Pulse",
    trackingData: {
      ref: "pulse-menubar",
    },
  },
];
